module.exports = __webpack_public_path__ + "img/reassign-pod.60d5944a.png";